import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 12, height = 13, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} class={customClass} viewBox='0 0 12 13'>
  <path d='M10.8 0.5H1.2C0.54 0.5 0 1.04 0 1.7V12.5L2.4 10.1H10.8C11.46 10.1 12 9.56 12 8.9V1.7C12 1.04 11.46 0.5 10.8 0.5Z' fill={color} />
</svg>
